module.exports = __webpack_public_path__ + "static/media/add-product-feature.4dc7a881.svg";